import { cssVar } from '@chakra-ui/styled-system';

const $width = cssVar("button-width", "max-content");
const $height = cssVar("button-height", "max-content");
const $radius = cssVar("button-radius");
const $padding = cssVar("button-padding");
let IconButton = {
  // Iris sizes
  baseStyle: {
    minHeight: $height.reference,
    minWidth: $width.reference,
    borderRadius: $radius.reference,
    px: $padding.reference
  },
  sizes: {
    xs: {
      [$width.variable]: "var(--vimeo-sizes-xs)",
      [$height.variable]: "var(--vimeo-sizes-xs)",
      [$radius.variable]: "4px",
      [$padding.variable]: ".25rem"
      // 4px
    },
    sm: {
      [$width.variable]: "var(--vimeo-sizes-sm)",
      [$height.variable]: "var(--vimeo-sizes-sm)",
      [$radius.variable]: "6px",
      [$padding.variable]: ".375rem"
      // 6px
    },
    md: {
      [$width.variable]: "var(--vimeo-sizes-md)",
      [$height.variable]: "var(--vimeo-sizes-md)",
      [$radius.variable]: "8px",
      [$padding.variable]: ".5rem"
      // 8px
    },
    lg: {
      [$width.variable]: "var(--vimeo-sizes-lg)",
      [$height.variable]: "var(--vimeo-sizes-lg)",
      [$radius.variable]: "10px",
      [$padding.variable]: ".625rem"
      // 10px
    },
    xl: {
      [$width.variable]: "var(--vimeo-sizes-xl)",
      [$height.variable]: "var(--vimeo-sizes-xl)",
      [$radius.variable]: "12px",
      [$padding.variable]: "0.75rem"
      // 12px
    }
  }
};

export { IconButton };
